<template>
<b-container fluid class="container">

<div>
  <b-card overlay class="step4">
  <div class="col-lg-8 mt-2">
    <b-row align-h="center">
      <b-col lg="12" class="text-left">
        <b-row cols="2">
          <b-col cols="12"><h1 class="titulo" style="color: #3B3B3B">Tenemos tus <span style="color: #A50932">resultados</span></h1></b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>

  <div class="col-lg-9 mt-2">
    <p class="parrafo" style="color: #3B3B3B;">Tienes una solicitud pendiente, para continuar <span style="color: #A50932">escanea el código QR </span>desde un dispositivo móvil</p>
  </div>
  <div class="col-lg-4 mt-1 ml-4 text-left">
    <b-row cols="1">
      <b-col class="mt-4">
        <h1 style="font-size: 17px; color: #3B3B3B"><b>Nombre:</b> <span style="color: #A50932">{{this.nombreCompleto}}</span></h1>
      </b-col>
      <b-col class="mt-5">
        <h1 style="font-size: 17px; color: #3B3B3B"><b>Folio:</b> <span style="color: #A50932">{{this.folio}}</span></h1>
      </b-col>
      <b-col class="mt-5">
        <h1 style="font-size: 16px; color: #3B3B3B"><b>Fecha y Hora:</b> <span style="color: #A50932">{{this.fechaHora}}</span></h1>
      </b-col>
      <b-col class="mt-5">
        <b-button class="mb-3 buttonf" @click.prevent="finalizar()" >¡ Finalizar !</b-button>
      </b-col>
    </b-row>  
  </div>

  <div class="col-md-5 datos5">
    <b-row>
      <div class="contenedorQR" id="qrcode"></div>
    </b-row>
  </div>
  </b-card>

          <b-modal ref="modalNoContinuar"  size="sm" hide-footer>
            <template #modal-title>
              <h5 >Continuar Solicitud</h5>
            </template>
              <div class="d-block text-center">
                <h6>Tu solicitud debe continuar desde un dispositivo móvil</h6>
               <b-button @click.prevent="salir()" style="width: 180px; height: 40px; font-style: normal; font-weight: 500;background: #A50932; color: #ffffff; border-radius: 10px;" class="mb-2 mt-4">¡Continuar!</b-button>
              </div>
           </b-modal>

</div>
</b-container>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
    name:"Resultados",

      data() {
      return {
          nombreCompleto:sessionStorage.getItem("nombre")+' '+sessionStorage.getItem("apellidop")+' '+sessionStorage.getItem("apellidom"),
          folio:sessionStorage.getItem("folioGuid"),
          fechaHora: sessionStorage.getItem("fechaGuid") +' / '+sessionStorage.getItem("horaGuid"),
          address:sessionStorage.getItem("guid"),
          acceso: '',
        };
    },

    mounted(){
       this.acceso = "https://pr.creditcheck.mx/produccion/CreditCheckEnrolamiento/#/resume/"+this.address;
       this.qrcode();
       //console.log('URL --> ',this.acceso)
    },
    methods: {
        qrcode() {
            let qrcode = new QRCode("qrcode", {
                text: this.acceso
            });

            return qrcode;
        },

    finalizar(){
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
              window.open("https://pr.creditcheck.mx/produccion/CreditCheckEnrolamiento/#/resume/"+this.address);
              window.history.go(-5);
              sessionStorage.clear();
      } else {
            this.$refs['modalNoContinuar'].show();
      }
    },

    salir(){
      window.history.go(-5);
      sessionStorage.clear();
      this.$refs['modalNoContinuar'].hide();
    },
 }
}

</script>

<style>

</style>